<template>
  <div class="ui-hero flex align-center container">
    <div class="img-container flex align-center">
      <transition name="trans-slider">
        <img :key="currentImage" :src="images[currentImage]" alt="Wisteria Lodge">
      </transition>
    </div>
    <div class="hero-content">
      <h1 class="c-primary">Welcome Home</h1>
      <p class="fw-regular">
        Wisteria Lodge is a one-bedroom furnished cottage situated in North-Western Johannesburg, featuring exposed wooden beams, screeded floors and an external terrace.
      </p>
    </div>
  </div>
</template>

<script>
import img1 from '@/assets/images/img1.jpg'
import img3 from '@/assets/images/img3.jpg'
import img4 from '@/assets/images/img4.jpg'
import img5 from '@/assets/images/img5.jpg'
import img6 from '@/assets/images/img6.jpg'
import img7 from '@/assets/images/img7.jpg'
import img8 from '@/assets/images/img8.jpg'
import img9 from '@/assets/images/img9.jpg'

export default {
  name: 'Hero',
  data () {
    return {
      currentImage: 0,
      images: [
        img1,
        img3,
        img4,
        img5,
        img6,
        img7,
        img8,
        img9
      ]
    }
  },
  methods: {
    rollImages () {
      setInterval(
        () => {
          if (this.currentImage <= 6) {
            this.currentImage++
          } else {
            this.currentImage = 0
          }
        },
        4500
      )
    }
  },
  beforeMount () {
    this.rollImages()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/Hero.vue